module.exports = new __parcel__URL__("roy-pablo.c7be3222.jpg").toString();